module.exports = __webpack_public_path__ + "img/gray.7869394a.png";